//#region IMPORT
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1 } from './PPE_BASIC_03_ColumnDefs';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';

function PPE_BASIC_03(props) {
  const searchInfo = useSelector((state) => state.SearchInfo);

  // 지급대장 조회 전용 그리드 컬럼
  const columnDefs1 = getColumnDefs1(props);

  //#region AuthButton 이벤트
  useEffect(() => {
    // 현재 탭이 2번이 아닌 경우 처리하지 않음
    if (props.value !== 2) return;

    if (props.filterClick3) {
      if (!props.validateSelection()) {
        props.setFilterClick3(false);
        return;
      }

      props.gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      props.setFilterClick3(false);
    }
    if (props.searchClick3) {
      props.ResetLogic1();
      if (!props.validateSelection()) {
        props.setSearchClick3(false);
        return;
      }

      props.SearchLogic1();
      props.setSearchClick3(false);
    }
    if (props.saveClick3) {
      if (!props.validateSelection()) {
        props.setSaveClick3(false);
        return;
      }

      props.SaveLogic1();
      props.setSaveClick3(false);
    }
    if (props.printClick3) {
      if (!props.validateSelection()) {
        props.setPrintClick3(false);
        return;
      }

      props.PrintLogic1();
      props.setPrintClick3(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.value,
    props.filterClick3,
    props.searchClick3,
    props.saveClick3,
    props.printClick3,
  ]);
  //#endregion
  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => {
          return params.data.no;
        }}
        fileDownloadYn1="Y"
        fileDownloadClick1={() => {
          if (!props.validateSelection()) return;

          props.ExcelDownload();
        }}
        fileUploadYn1="N"
        addYn1="Y"
        saveYn1="N"
        deleteYn1="N"
        addClick1={() => {
          if (!props.validateSelection()) return;

          GridFunctions.addClick(
            props.gridRef1,
            props.getDefaultNewRow1?.() ?? {}
          );
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        title1={'보호구 지급대장'}
        gridRef={props.gridRef1}
        editable={true}
        stopEditingWhenCellsLoseFocus={false}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        rowSelection={'multiple'}
        onCellValueChanged={(e) => {
          const key = e.data.no;

          e.node.setData({
            ...e.data,
            editYn: 'Y',
          });

          props.setChangedRowData1?.((prev) => {
            const filtered = prev.filter((row) => row.no !== key);
            return [...filtered, { ...e.data, editYn: 'Y' }];
          });
        }}
        onCellClicked={(e) => {
          const gridApi = props.gridRef1.current.api;
          const clickedRowIndex = e.rowIndex;
          const isCheckboxClick = e.event?.target?.type === 'checkbox';
          const colField = e.column?.getColDef?.()?.field ?? e.colDef?.field;
          const isDateTimeCell = colField === 'createDate';

          if (!isCheckboxClick && !isDateTimeCell) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');

            const copied = JSON.parse(JSON.stringify(e.data));
            props.handleRowSelection(copied, clickedRowIndex);

            gridApi
              .getDisplayedRowAtIndex(clickedRowIndex)
              ?.setSelected(true, false);
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);
          props.selectedRowNosRef.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
      />
    </React.Fragment>
  );
}

export default PPE_BASIC_03;
